module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3-521a0f0c6fb915b49617e3b2b14e2c8f.webp";